// @ts-check
import { defineConfig } from '../utils';

export function expeditions() {
  return defineConfig({
    properties: {
      'Expediciones.MostrarNombreDireccion': {
        defaultValue: false,
      },
    },
  });
}
